import { api } from "@/lib/api";

const sid = () => {
  let s = sessionStorage.getItem("ibs-session");
  if (!s) { s = Math.random().toString(36).slice(2) + Date.now().toString(36); sessionStorage.setItem("ibs-session", s); }
  return s;
};

export const makeTracker = (slug, headers = {}) => (type, data = {}) =>
  api.post(`/public/books/${slug}/events`, { type, session: sid(), ...data }, { headers }).catch(() => {});

let gaLoaded = false;
export const loadGA = async () => {
  if (gaLoaded) return;
  gaLoaded = true;
  try {
    const { data } = await api.get("/public/settings");
    const id = data.ga_measurement_id;
    if (!id || !/^G-[A-Z0-9]+$/i.test(id)) return;
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { window.dataLayer.push(arguments); }; // eslint-disable-line prefer-rest-params
    window.gtag("js", new Date());
    window.gtag("config", id);
  } catch { /* GA optional */ }
};
